import * as React from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process, State, DataResult } from "@progress/kendo-data-query"
import "@progress/kendo-theme-material/dist/all.css";
import {
    ApprovedIcon,
    NotApprovedIcon
} from "../../_uiComponents/common/DataGridComponents";
import { Button } from "@progress/kendo-react-buttons";
import { UiAccordian } from "../../_uiComponents/common/form/UiToggleArea";
import SalesDataManagementFilterForm from "./forms/SalesDataManagementFilterForm";
import { SearchBarWr } from "../../_uiComponents/common/form/UiInputComponents";

const products = [
    {
        id: 1,
        salesFileType: "File Type 1",
        application:'application 1',
        salesDate: '10/30/2024',
        uploadedDate: '10/30/2024',
        status: true,
    },
    {
        id: 2,
        salesFileType: "File Type 2",
        application:'application 2',
        salesDate: '09/30/2024',
        uploadedDate: '10/30/2024',
        status: false,
    },
    {
        id: 3,
        salesFileType: "File Type 3",
        application:'application 3',
        salesDate: '08/30/2024',
        uploadedDate: '10/30/2024',
        status: true,
    },
    {
        id: 4,
        salesFileType: "Sales4",
        application:'application 4',
        salesDate: '06/30/2024',
        uploadedDate: '10/30/2024',
        status: false,
    },

]

const initialDataState = {
    skip: 0,
    take: 3,
};

const initialSort = [
    {
        field: "application",
        dir: "asc",
    },
];

const SalesDataManagementGrid = () => {
    const [page, setPage] = React.useState(initialDataState);
    const [sort, setSort] = React.useState(initialSort);
    const [pageSizeValue, setPageSizeValue] = React.useState();
    const [dataState, setDataState] = React.useState();
    const [resultState, setResultState] = React.useState(
        process(products, initialDataState)
    );

    const pageChange = (event) => {
        const targetEvent = event.targetEvent;
        setResultState(process(products, event.page.skip, event.page.take));
        const take =
            targetEvent.value === "All" ? products.length : event.page.take;
        if (targetEvent.value) {
            setPageSizeValue(targetEvent.value);
        }
        setPage({
            ...event.page,
            take,
        });
    };

    const onDataStateChange = React.useCallback((e) => {
        setDataState(e.dataState);
        setSort(e.sort);
        setResultState(process(products, e.dataState));

    }, []);


    const StatusCell = (props) => {
        return (
            <td
                {...props.tdProps}
            >
                {props.dataItem.status === true ? <ApprovedIcon /> : <NotApprovedIcon />}
            </td>
        );
    };

    const DownloadSummary = (props) => {
        return (
            <td
                {...props.tdProps}
                className="sba-telerik-grid-button"
            >
                <Button themeColor={"primary"}>Download Summary</Button>
            </td>
        );
    };


    return (
        <div className='sba-telerik-components-wr'>
            <UiAccordian>
                <SearchBarWr>
                    <SalesDataManagementFilterForm />
                </SearchBarWr>
            </UiAccordian>
            <Grid
                data={resultState.data.slice(page.skip, page.take + page.skip)}
                skip={page.skip}
                take={page.take}
                total={products.length}
                sortable={true}
                fixedScroll={true}
                sort={sort}
                pageable={{
                    buttonCount: 4,
                    pageSizes: [5, 10, 15, "All"],
                    pageSizeValue: pageSizeValue,
                }}
                {...dataState}
                onPageChange={pageChange}
                onDataStateChange={onDataStateChange}

            >
                <GridColumn field="application" title="Application"  width="200px"/>
                <GridColumn field="salesDate" title="Sales Date" width="200px"/>
                <GridColumn field="uploadedDate" title="Uploaded Date" width="200px"/>
                <GridColumn field="salesFileType" title="Sales File Type" width="200px"/>
                <GridColumn field="status" title="Status" width="150px" cells={{
                    data: StatusCell
                }} />
                <GridColumn cells={{
                    data: DownloadSummary
                }} width="250px"/>
            </Grid>
        </div>
    );
};
export default SalesDataManagementGrid;
